(function () {
    angular.module('informaApp')
        .component('newFeaturePopupHeader', {
            templateUrl: 'components/new-feature-popup/new-feature-popup-header/template.html',
            bindings: {
                onClose: '<'
            }
        })
})();
